import { Controller } from "@hotwired/stimulus"
import { registerGuestPwa } from "../services/guest_platform/pwa_registration"

export default class extends Controller {
  static values = {
    serviceWorkerUrl: String,
    scope: String
  }

  connect() {
    if (!this.hasServiceWorkerUrlValue || !this.hasScopeValue) return

    registerGuestPwa(this.serviceWorkerUrlValue, this.scopeValue).catch(() => {
      // PWA support is progressive enhancement; registration failure must not affect guest access.
    })
  }
}
